class Api {
  async _init() {
    if (!window._vlc) window._vlc = window._media

    window.playmore = { media: window._media, vlc: window._vlc, device: window._device, platform: window._platform }
    await this.loadResources()
    await _$.sleep(2000)
    await this.makeConfigurations()

    this.addListeners()

    // Do anything when the worker is ready
    //_$.vue.$once("worker.init", () => {})
    // Do anything when the config is init // updated
    _$.vue.$once("config.init", () => {
      if (__.device.config("playmoreatv.videojs")) {
        __._hls = __._hlsVideoJS
        __._vod = __._hlsVideoJS
      }
    })
    return true
  }

  addListeners() {
    document.onkeydown = e => _$.nav.onKeyDown({ keyCode: e.detail }, ![3].includes(e.detail))
    document.onkeyup = e => ([209, 64].includes(e.detail) ? _$.nav.onKeyDown({ keyCode: e.detail }, false) : _$.nav.onKeyUp())

    document.addEventListener(
      "stbEvent",
      event => {
        const events = Object.keys(event.detail)
        events.forEach(key => _$.handler.emit(key, event.detail[key]))
      },
      false
    )

    _$.vue.$on("mediaPlaying", () => !__.device.isPowerOn() && __.media.stop().then(() => __.media.request(true)))

    _$.vue.$on("standBy", async () => {
      // Reclaim platform before sleep so wake starts from Playroom instead of HDMI/TV app.
      playmore.platform.returnToPlatform()
      await _$.sleep(500)
      playmore.platform.returnToPlatform()
      __.platform.go().then(() => __.media.request(true))
    })
    _$.vue.$on("powerOn", async () => {
      __.media.request()
      // TCL TV app can claim focus right after wake; re-assert platform focus with retries.
      await _$.sleep(1200)
      playmore.platform.returnToPlatform()
      await _$.sleep(2000)
      playmore.platform.returnToPlatform()
    })
  }
  async makeConfigurations() {
    window._vlc.stop()
    window._media.stop()

    window._vlc.setDisplayMetrics(1920, 1080, 0, 0, "BEHIND")
    window._media.setDisplayMetrics(1920, 1080, 0, 0, "BEHIND")

    return true
  }
  async loadResources() {
    return true
  }
  async getProperties() {
    try {
      return JSON.parse(playmore.device.getProperties().replace(/"macAddress":"\["(.+?)"\]"/, '"macAddress":"$1"'))
    } catch (err) {
      return _$.error(err)
    }
  }
}

export default Api
